export default __webpack_public_path__ + "static/media/us-flag.98032cf6.png";